import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { Provider } from "jotai";
import UserAuthProvider from "./pages/admin/users/auth.provider";
import { RouterProvider } from "react-router-dom";
import navRouter from "./routes";
import { Suspense } from "react";
import ErrorBoundary from "./components/error.boundary";
import "./App.css";
import ComponentFillGenericLoader from "./components/loader/generic.spinner";
import "./utils/daysjs.config"; // Ensure dayjs is configured globally

function App() {
  const queryClient = new QueryClient();

  return (
    <ErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <QueryClientProvider client={queryClient}>
          <Provider>
            <UserAuthProvider>
              <Suspense fallback={<ComponentFillGenericLoader />}>
                <RouterProvider router={navRouter} />
              </Suspense>
            </UserAuthProvider>
          </Provider>
        </QueryClientProvider>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
